import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { ReferenceInfo } from '@blaze-shared/api-contracts-domain';

import { formatWorkflowReferenceLabel, groupWorkflowReferences } from './workflow-references.utils';

@Component({
  selector: 'blaze-workflow-references-list',
  imports: [MatIconModule],
  templateUrl: './workflow-references-list.component.html',
  styleUrls: ['./workflow-references-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkflowReferencesListComponent {
  readonly references = input.required<ReferenceInfo[]>();
  readonly referenceSelected = output<ReferenceInfo>();
  protected readonly formatWorkflowReferenceLabel = formatWorkflowReferenceLabel;
  protected readonly sections = computed(() => groupWorkflowReferences(this.references()));
}
